(() => {
  // Shopify Custom Pixelへ連携するテーマイベントを検知する
  const fired = new Set();
  let ticking = false;

  /**
   * Shopify Custom Event 共通送信
   */
  function publish(eventName, data = {}) {
    const analytics = window.Shopify?.analytics;

    if (!analytics?.publish) return;

    Promise.resolve(
      analytics.publish(`theme:${eventName}`, {
        page_location: window.location.href,
        page_path: window.location.pathname,
        page_title: document.title,
        page_referrer: document.referrer || null,
        ...data,
      })
    ).catch((error) => {
      console.error('[Theme analytics]', eventName, error);
    });
  }

  /**
   * ----------------------------------------
   * Scroll Depth
   * ----------------------------------------
   */

  const scrollThresholds = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

  function trackScrollDepth() {
    const doc = document.documentElement;

    const scrollTop = window.scrollY || doc.scrollTop || document.body.scrollTop || 0;

    const viewportHeight = window.innerHeight;

    const documentHeight = Math.max(doc.scrollHeight, document.body.scrollHeight);

    if (documentHeight <= 0) return;

    const percent = Math.min(100, Math.floor(((scrollTop + viewportHeight) / documentHeight) * 100));

    scrollThresholds.forEach((threshold) => {
      const key = `scroll_${threshold}`;

      if (percent >= threshold && !fired.has(key)) {
        fired.add(key);

        publish('scroll_depth', {
          percent_scroll: threshold,
        });
      }
    });
  }

  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;

      ticking = true;

      requestAnimationFrame(() => {
        trackScrollDepth();
        ticking = false;
      });
    },
    { passive: true }
  );

  // viewportを含めた初期到達率も計測する
  trackScrollDepth();

  /**
   * ----------------------------------------
   * Engagement Timer
   * 90秒滞在
   * ----------------------------------------
   */

  window.setTimeout(() => {
    publish('engagement_90s', {
      engagement_seconds: 90,
    });
  }, 90000);

  /**
   * ----------------------------------------
   * 明示的なUIイベント
   *
   * HTML側で
   * data-theme-event="xxxxx"
   * を付けた要素をクリックした場合に送信
   * ----------------------------------------
   */

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    // 全クリック用
    const clickedTarget = event.target.closest(
      'a, button, input, select, textarea, [role="button"], [data-theme-event]'
    );

    if (!clickedTarget) return;

    publish('clicked', {
      element_id: clickedTarget.id || null,
      element_tag: clickedTarget.tagName || null,
      element_href: clickedTarget.getAttribute('href') || null,
      element_text: clickedTarget.matches('input, select, textarea')
        ? null
        : clickedTarget.textContent?.trim().slice(0, 200) || null,
      element_classes: clickedTarget.getAttribute('class') || null,
      element_target: clickedTarget.getAttribute('target') || null,
      element_name: clickedTarget.getAttribute('name') || null,
      element_type: clickedTarget.getAttribute('type') || null,
    });

    // data-theme-event がある場合は、固有イベントも発火
    const themeTarget = event.target.closest('[data-theme-event]');
    if (!themeTarget) return;

    const eventName = themeTarget.getAttribute('data-theme-event');
    if (!eventName) return;

    publish(eventName, {
      element_id: themeTarget.id || null,
      element_tag: themeTarget.tagName || null,
      element_href: themeTarget.getAttribute('href') || null,
      element_text: themeTarget.matches('input, select, textarea')
        ? null
        : themeTarget.textContent?.trim().slice(0, 200) || null,
      element_classes: themeTarget.getAttribute('class') || null,
      element_target: themeTarget.getAttribute('target') || null,
      element_name: themeTarget.getAttribute('name') || null,
      element_type: themeTarget.getAttribute('type') || null,
    });
  });
})();
